import { useRegisterAreaHeader } from '@/shared/navigation';

/** Zeile unter dem Titel: wie viele warten, welcher Stand — und ehrlich, wenn nichts geladen ist. */
export function headerLine(
  count: number | undefined,
  updatedAt: number,
  online: boolean,
  failed: boolean,
): string {
  const time = updatedAt
    ? `Stand ${new Date(updatedAt).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}`
    : failed
      ? 'Liste nicht geladen'
      : online
        ? 'wird geladen'
        : 'noch nichts geladen';
  if (!online) return `Keine Verbindung · ${time}`;
  if (count === undefined) return time;
  return `${count} nicht beantwortet · ${time}`;
}

/** Am Handy trägt die Unterhaltung ihren eigenen Kopf; der Ersatzkopf des Gerüsts bleibt weg. */
export function QuietAreaHeader() {
  useRegisterAreaHeader();
  return null;
}
